import AjaxService, { validateResponse } from '../services/ajax-service';

import { batch } from './global-api';
import { handleServerError } from 'shared-services/error-service';

export const fetchCustomFields = ({ projectId, limit, offset }) => {
    return AjaxService({
        method: 'get',
        url: 'fields',
        params: {
            project_id: projectId,
            limit,
            offset
        }
    })
    .then(response => validateResponse(response, 'items').data)
    .catch(handleServerError);
}

export const fetchCustomFieldsValues = (association, associationId) => {
    return AjaxService({
        method: 'get',
        url: `${association}s/${associationId}/fields`
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const createCustomField = ({ associations, associationId, fieldId, type, name, description, hidden, currency, options, cost_per_hour, tracking_type, in_library, projects }) => {
    if (fieldId) {
        return AjaxService({
            method: 'post',
            url: `fields/${fieldId}/attach`,
            data: {
                association: associations[0],
                project_id: projects[0]
            }
        })
        .then(response => response.data)
        .catch(handleServerError);
    }
    return AjaxService({
        method: 'post',
        url: 'fields',
        data: {
            association: associations[0],
            field_id: fieldId,
            type,
            name,
            description,
            roles: hidden,
            currency,
            options,
            cost_per_hour,
            tracking_type,
            save: in_library,
            project_id: projects[0]
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const updateCustomField = (customFieldId, { name, description, association, currency, cost_per_hour, tracking_type }) => {
    return AjaxService({
        method: 'put',
        url: `fields/${customFieldId}`,
        data: {
            name,
            description,
            association,
            currency,
            cost_per_hour,
            tracking_type
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const setVisibility = (customFieldId, visible, roles) => {
    return AjaxService({
        method: 'post',
        url: `fields/${customFieldId}/${visible ? 'reveal' : 'hide'}`,
        data: { roles }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const addCustomFieldOptions = (customFieldId, options) => {
    return AjaxService({
        method: 'put',
        url: `fields/${customFieldId}/options`,
        data: { options }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const removeCustomFieldOptions = (customFieldId, options) => {
    return AjaxService({
        method: 'delete',
        url: `fields/${customFieldId}/options`,
        data: { options }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const updateCustomFieldOption = (customFieldId, optionId, { value, color }) => {
    return AjaxService({
        method: 'put',
        url: `fields/${customFieldId}/options/${optionId}`,
        data: {
            value,
            color
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const removeCustomField = customFieldId => {
    return AjaxService({
        method: 'delete',
        url: `fields/${customFieldId}`
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const setCustomFieldValue = ({ association, associationId, fieldId, value }, configOnly) => {
    const requestConfig = {
        method: 'put',
        url: `${association}s/${associationId}/fields/${fieldId}`,
        data: { value }
    };

    if (configOnly) {
        return requestConfig;
    }

    return AjaxService(requestConfig)
        .then(response => response.data)
        .catch(handleServerError);
}

export const setCustomFieldsValue = updateProps => {
    return batch(updateProps.map(props => {
        const { method, url, data: body } = setCustomFieldValue(props, true);

        return { method, url, body };
    }));
}
